import type { User } from "@bezoned/shared/fluid/office-schema-factory.js";
import { AvatarGroup } from "@fluentui/react-components";
import { Html } from "@react-three/drei";
import type { Vector3 } from "three";

import { useBezonedContext } from "../../../../hooks/use-bezoned-context.js";
import { UserAvatar } from "./user-avatar.js";

interface SeatedAvatarListProps {
  users: User[];
  seats: Vector3[];
}

export const SeatedAvatarList = ({ users, seats }: SeatedAvatarListProps) => {
  const { ContextBridge } = useBezonedContext();

  if (users.length === 0 || seats.length === 0) {
    return null;
  }

  return (
    <>
      {users.map((user, index) => {
        const seat = seats[index];

        if (!seat) {
          return null;
        }

        return (
          <Html
            key={user.id}
            position={seat}
            sprite
            style={{
              pointerEvents: "none",
              userSelect: "none",
            }}
            transform
          >
            <div
              data-blocks-hover="true"
              data-office-avatar-overlay
              style={{ pointerEvents: "auto" }}
            >
              <ContextBridge>
                <AvatarGroup size={48}>
                  <UserAvatar user={user} />
                </AvatarGroup>
              </ContextBridge>
            </div>
          </Html>
        );
      })}
    </>
  );
};
